import { apiGet, apiPost, apiPatch } from './apiClient.js';

export const usersApi = {
  list: () => apiGet('/api/users').then((r) => r.items.users),
  create: (body) => apiPost('/api/users', body),
  update: (id, body) => apiPatch(`/api/users/${id}`, body),

  /* Das eigene Kennwort. Ohne Kennung im Aufruf - der Dienst nimmt gar keine
     entgegen, sondern die Person aus dem geprüften Token. Damit gibt es hier
     keinen Aufruf, den man versehentlich auf einen Kollegen richten könnte. */
  changeOwnPassword: (body) => apiPost('/api/users/me/password', body),

  /* Zurücksetzen durch den Firmenadministrator. Zurück kommt ein Einmal-Link,
     KEIN Kennwort: der Administrator soll den Zugang wiederherstellen können,
     nicht das Konto übernehmen. */
  resetPassword: (id) => apiPost(`/api/users/${id}/password-reset`, {}),
};
